export default {
    text: '250ms ease-out',
    button: '250ms ease-out',
};
